import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Upload, Trash2, Plus, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GlassCard } from "@/components/erp";
import { eslesir } from "@/lib/ara";
import { useMarkaLogolari, logolariYenile, logoUrl, logoAnahtar } from "@/lib/markaLogo";
import api, { errMsg } from "@/lib/api";

const Satir = ({ marka, url, onYukle, onSil, busy }) => {
  const t = logoAnahtar(marka);
  return (
    <div className="flex items-center gap-3 p-3 rounded-xl border border-white/10 bg-white/[0.03]" data-testid={`logo-satir-${t}`}>
      {url ? <img src={url} alt={marka} className="w-12 h-12 rounded-lg object-contain bg-white p-1 shrink-0" data-testid={`logo-resim-${t}`} />
        : <span className="w-12 h-12 rounded-lg grad-bg flex items-center justify-center font-head font-bold text-white shrink-0">{marka.charAt(0)}</span>}
      <span className="flex-1 min-w-0 truncate font-medium">{marka}</span>
      <label className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs border border-white/15 hover:bg-white/10 cursor-pointer ${busy ? "opacity-50 pointer-events-none" : ""}`} data-testid={`logo-yukle-${t}`}>
        <Upload className="w-3.5 h-3.5" />{url ? "Değiştir" : "Logo yükle"}
        <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" data-testid={`logo-dosya-${t}`} onChange={(e) => { const f = e.target.files?.[0]; if (f) onYukle(marka, f); e.target.value = ""; }} />
      </label>
      {url && <button data-testid={`logo-sil-${t}`} onClick={() => onSil(t)} title="Logoyu kaldır" className="p-1.5 rounded-lg text-muted-foreground hover:text-red-300 hover:bg-white/5"><Trash2 className="w-4 h-4" /></button>}
    </div>
  );
};

export const MarkaLogolari = () => {
  const logolar = useMarkaLogolari();
  const [markalar, setMarkalar] = useState([]);
  const [kayitli, setKayitli] = useState([]);
  const [yeni, setYeni] = useState("");
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const yukleListe = () => api.get("/marka-logolari").then((r) => setKayitli(r.data.map((x) => x.marka))).catch(() => {});
  useEffect(() => {
    api.get("/araclar/oneriler").then((r) => setMarkalar(r.data.markalar)).catch(() => {});
    yukleListe();
  }, []);
  const tum = [...new Map([...markalar, ...kayitli].map((m) => [logoAnahtar(m), m])).values()]
    .sort((a, b) => a.localeCompare(b, "tr")).filter((m) => eslesir(q, m));
  const yukle = async (marka, f) => {
    const fd = new FormData(); fd.append("marka", marka); fd.append("dosya", f); setBusy(true);
    try { await api.post("/marka-logolari", fd, { headers: { "Content-Type": "multipart/form-data" } }); await logolariYenile(); await yukleListe(); toast.success(`${marka} logosu kaydedildi`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const sil = async (a) => {
    try { await api.delete(`/marka-logolari/${a}`); await logolariYenile(); await yukleListe(); toast.success("Logo kaldırıldı"); } catch (e) { toast.error(errMsg(e)); }
  };
  const ekle = () => { const m = yeni.trim().toLocaleUpperCase("tr"); if (!m) return; setMarkalar((l) => [...l, m]); setYeni(""); };
  return (
    <GlassCard className="p-6 space-y-4" data-testid="marka-logolari">
      <p className="text-sm text-muted-foreground">Bayi portalındaki "Aracıma göre bul" ekranında marka kartlarında görünür. PNG, JPEG veya WEBP, en fazla 5 MB; kare ve şeffaf arka planlı logolar en iyi sonucu verir. Markalar ürünlerdeki araç bilgisinden gelir; listede olmayanı aşağıdan ekleyip logosunu yükleyin (logo yüklenmeyen yeni marka sayfa yenilenince listeden düşer).</p>
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1"><Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input data-testid="logo-ara" placeholder="Marka ara…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9 bg-white/5" /></div>
        <div className="flex gap-2">
          <Input data-testid="logo-yeni-marka" placeholder="Yeni marka adı" value={yeni} onChange={(e) => setYeni(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") ekle(); }} className="bg-white/5 sm:w-48" />
          <button data-testid="logo-marka-ekle" onClick={ekle} className="inline-flex items-center gap-1 px-3 rounded-full text-xs border border-white/15 hover:bg-white/10 whitespace-nowrap"><Plus className="w-3.5 h-3.5" />Ekle</button>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-2">
        {tum.map((m) => <Satir key={m} marka={m} url={logoUrl(logolar, m)} onYukle={yukle} onSil={sil} busy={busy} />)}
      </div>
      {!tum.length && <p className="text-sm text-muted-foreground text-center py-6" data-testid="logo-bos">Henüz marka yok. Ürünlere araç bilgisi girince ya da yukarıdan ekleyince burada listelenir.</p>}
    </GlassCard>
  );
};
